import script from "./ContentWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./ContentWidget.vue?vue&type=script&setup=true&lang=js"

import "./ContentWidget.vue?vue&type=style&index=0&id=e31dbf78&lang=scss"

const __exports__ = script;

export default __exports__